import { render, staticRenderFns } from "./onPending.vue?vue&type=template&id=ad47670c&scoped=true&"
import script from "./onPending.vue?vue&type=script&lang=js&"
export * from "./onPending.vue?vue&type=script&lang=js&"
import style0 from "./onPending.vue?vue&type=style&index=0&id=ad47670c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad47670c",
  null
  
)

export default component.exports